import { useDeliveryApi } from 'infrastructure/api';
import { ResourceData } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { cycleSettingsValidation, rejectValidation } from './CycleSettings/cycleSettingsValidation';
import { demoValidation } from './sdlcActivities/Demo/demoValidation';
import { planningValidation } from './sdlcActivities/Planning/planningValidation';

const useProjectCycleService = () => {
  const { sendPostRequest, sendPutRequest, sendGetRequest } = useDeliveryApi();

  const cycleSearch = async (id: string, request: ResourceData) => {
    const searchParams = cloneDeep(request);
    const response = await sendPostRequest(`/projects/${id}/cycle-activities/search`, searchParams);
    return response.json();
  };

  const updateDemo = async (id: string, data: any): Promise<any> => {
    const res = await sendPutRequest(`/projects/cycle-activities/${id}/demo`, data);
    return res.json();
  };

  const updatePlanning = async (id: string, data: any): Promise<any> => {
    const res = await sendPutRequest(`/projects/cycle-activities/${id}/planning`, data);
    return res.json();
  };

  const getCyclesById = async (id: string): Promise<object> => {
    const response = await sendGetRequest(`/projects/cycle-activities/${id}`);
    return response.json();
  };

  // Settings

  const updateCycleSettings = async (id: string, data: any): Promise<any> => {
    const res = await sendPutRequest(`/projects/${id}/cycle-settings`, data);
    return res.json();
  };

  const approveCycleSettings = async (id: string, data: any): Promise<any> => {
    const res = await sendPutRequest(`/projects/${id}/cycle-settings/approve`, data);
    return res.json();
  };

  const rejectCycleSettings = async (id: string, data: any): Promise<any> => {
    const res = await sendPutRequest(`/projects/${id}/cycle-settings/reject`, data);
    return res.json();
  };

  const getRejectValidationSchema = () => Promise.resolve(rejectValidation);
  const getDemoValidationSchema = () => Promise.resolve(demoValidation);
  const getPlanningValidationSchema = () => Promise.resolve(planningValidation);
  const getCycleSettingsValidationSchema = () => Promise.resolve(cycleSettingsValidation);

  return {
    updateDemo,
    cycleSearch,
    updatePlanning,
    getCyclesById,
    updateCycleSettings,
    approveCycleSettings,
    rejectCycleSettings,
    getRejectValidationSchema,
    getDemoValidationSchema,
    getPlanningValidationSchema,
    getCycleSettingsValidationSchema,
  };
};

export default useProjectCycleService;
